Header = {
    header:{},
    trashold: 50,

    init: function(trashold){
        this.header = $('.row.header');
        this.trashold = trashold;

        Header.resize();

        $('[component="page"]').scroll(function(){
            Header.adjustHeight();
        });
    },

    adjustHeight: function() {

        var width = window.innerWidth;
        var isTop = $('[component="page"]').scrollTop() > this.trashold

        if (width > 980) {
            if (isTop) {
                $('[component="header"]').attr('scrolled', '');
                $('[component="directory"]').attr('scrolled', '');
            } else {
                $('[component="header"]').removeAttr('scrolled');
                $('[component="directory"]').removeAttr('scrolled');
            }
        }
    },

    resize: function(){

        // this.trashold = window.innerWidth > 1024 ? 100 : 45;
        var cookieHeight = $('.euCookies').outerHeight() + parseInt($('.euCookies').css('margin-bottom'));

        if(Cookies.get('closedEuCookieBar')){
            cookieHeight = 0
        }

        this.trashold = this.trashold + cookieHeight;
    }

};